import * as React from "react";
import { Container } from "@material-ui/core";

import { ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";

import { getOrgOverviewTimeframe } from "./overview.util";
import { IOrgOverview } from "./overview.types";

import { HeroStatGrid } from "./hero-stat-grid";
import { ChartGrid } from "./chart-grid";
import { SectionHeader } from "./section-header";
import { Title } from "../title";

export interface OverviewProps {
  orgOverview: IOrgOverview | null;
}

export const Overview = ({ orgOverview }: OverviewProps) => {
  if (!orgOverview) {
    return null;
  }

  const [startDate, endDate] = getOrgOverviewTimeframe(orgOverview);

  const overviewStartDate = startDate && new ZonedMoment(startDate).format("MMM D");
  // NB: the previous period ends a day before the current period starts
  const overviewEndDate = endDate && new ZonedMoment(endDate).subtract(1, "days").format("MMM D");
  const heroStatTimeFrame =
    startDate && endDate
      ? `
        ${overviewStartDate} - ${overviewEndDate}
      `
      : "";

  return (
    <Container maxWidth={false}>
      <Title>Overview</Title>
      <SectionHeader title="New activity" period={heroStatTimeFrame} />
      <HeroStatGrid orgOverview={orgOverview} startDate={startDate} endDate={endDate} />
      <SectionHeader title="Cumulative activity" period="Last 12 months" />
      <ChartGrid orgOverview={orgOverview} />
    </Container>
  );
};
